export type {
  SkipToken,
  SuspenseQueryHookOptions,
  UseSuspenseQueryResult,
} from '@apollo/client';
export {skipToken, useSuspenseQuery} from '@apollo/client';
export * from '@apollo/react-hooks';
// Apollo client values/types are funneled through this module so that the
// eventual Apollo Client v3 upgrade only needs to change this file.
export type {
  ExecutionResult,
  OperationVariables,
  QueryResult,
} from '@apollo/react-common';
export type {ApolloClient, ApolloQueryResult} from 'apollo-client';
export {ApolloError, NetworkStatus} from 'apollo-client';

// As of Feb 2024, query dedupe is much more impactful from a performance perspective than query abort.
// We're disabling query dedupe for now, but we may want to re-enable it in the future.
// It must be disabled in order to enable Apollo's internal query dedupe, since aborting inflight queries
// with query dedupe enabled causes Apollo to never fire the query again, even on remount.

// We wrap Apollo's `useQuery` in logic which aborts the query when the component unmounts.
// Apollo uses `fetch` under the hood, which is cancellable via `AbortController`.
// See https://developer.mozilla.org/en-US/docs/Web/API/AbortController.
// export const useQuery: typeof useApolloQuery = (document, options = {}) => {
//   // This `useMemo` is required so we only create one `AbortController` on mount.
//   const controller = useMemo(() => new AbortController(), []);
//   // This only runs once on component unmount.
//   useEffect(() => () => controller.abort(), [controller]);

//   // Preserve passed in options while populating `options.context.fetchOptions.signal`.
//   const optionsWithSignal = produce(options, draft => {
//     draft.context = draft.context ?? {};
//     draft.context.fetchOptions = draft.context.fetchOptions ?? {};
//     draft.context.fetchOptions.signal = controller.signal;
//   });

//   return useApolloQuery(document, optionsWithSignal);
// };
